import { useEffect } from 'react'

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://xegheplinhlinh36.com'
const SITE_NAME = 'Xe ghép Thanh Hóa - Hà Nội'
const DEFAULT_ROBOTS = 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1'

export const siteUrl = SITE_URL
export const siteName = SITE_NAME
export const buildSiteUrl = (path = '/') => `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`

type SeoOptions = {
   title: string
   description: string
   path?: string
   ogType?: 'website' | 'article'
   keywords?: string[]
   structuredData?: Record<string, any> | Record<string, any>[]
}

const setMetaTag = (selector: string, attributeName: 'name' | 'property', attributeValue: string, content: string) => {
   let tag = document.head.querySelector<HTMLMetaElement>(selector)

   if (!tag) {
      tag = document.createElement('meta')
      tag.setAttribute(attributeName, attributeValue)
      document.head.appendChild(tag)
   }

   tag.setAttribute('content', content)
}

const setCanonical = (href: string) => {
   let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')

   if (!link) {
      link = document.createElement('link')
      link.setAttribute('rel', 'canonical')
      document.head.appendChild(link)
   }

   link.setAttribute('href', href)
}

const normalizeStructuredData = (structuredData: SeoOptions['structuredData']) => {
   if (!Array.isArray(structuredData)) return structuredData

   return {
      '@context': 'https://schema.org',
      '@graph': structuredData.map((item) => {
         const { '@context': _context, ...schema } = item
         return schema
      })
   }
}

export const usePageSeo = ({ title, description, path = '/', ogType = 'website', keywords, structuredData }: SeoOptions) => {
   useEffect(() => {
      const canonicalUrl = buildSiteUrl(path)
      const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`

      document.title = fullTitle
      setMetaTag('meta[name="description"]', 'name', 'description', description)
      setMetaTag('meta[name="robots"]', 'name', 'robots', DEFAULT_ROBOTS)
      if (keywords?.length) {
         setMetaTag('meta[name="keywords"]', 'name', 'keywords', keywords.join(', '))
      }
      setMetaTag('meta[property="og:title"]', 'property', 'og:title', fullTitle)
      setMetaTag('meta[property="og:description"]', 'property', 'og:description', description)
      setMetaTag('meta[property="og:url"]', 'property', 'og:url', canonicalUrl)
      setMetaTag('meta[property="og:type"]', 'property', 'og:type', ogType)
      setMetaTag('meta[property="og:site_name"]', 'property', 'og:site_name', SITE_NAME)
      setMetaTag('meta[property="og:locale"]', 'property', 'og:locale', 'vi_VN')
      setMetaTag('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image')
      setMetaTag('meta[name="twitter:title"]', 'name', 'twitter:title', fullTitle)
      setMetaTag('meta[name="twitter:description"]', 'name', 'twitter:description', description)
      setCanonical(canonicalUrl)

      const existingStructuredData = document.getElementById('page-structured-data')
      existingStructuredData?.remove()

      if (structuredData) {
         const script = document.createElement('script')
         script.id = 'page-structured-data'
         script.type = 'application/ld+json'
         script.text = JSON.stringify(normalizeStructuredData(structuredData))
         document.head.appendChild(script)
      }
   }, [title, description, path, ogType, keywords, structuredData])
}
